import { useFormikContext } from 'formik'
import React from 'react'

import { SelectedProducts } from '@components/common/SelectedProducts'
import { Subsection, useMediaQueryContext, useModalContext } from '@fourthwall/components'
import { useOffersByIdsQuery } from '@hooks/useOffersByIdsQuery'
import { YOU_FULFILL } from '@modules/Dashboard/Product/Product.consts'
import { SelectProductsModal } from '@modules/Dashboard/modules/SelectProductsModal'

import type { FormValues } from '../../ShippingGroup.types'

type ProductsProps = {
  isSelfFulfilled: boolean
}

export const Products = ({ isSelfFulfilled }: ProductsProps) => {
  const media = useMediaQueryContext()
  const { open } = useModalContext()
  const { values, setFieldValue, errors, submitCount } = useFormikContext<FormValues>()
  const { offersByIdsQuery } = useOffersByIdsQuery([values.selectedProductsIds || []])

  const openSelectProductsModal = () =>
    open(SelectProductsModal, {
      selectedIds: values.selectedProductsIds,
      submitButtonLabel: 'Confirm',
      params: {
        fulfillmentService: isSelfFulfilled ? YOU_FULFILL : undefined,
      },
      emptyMessage: `You have not yet created any products that ${isSelfFulfilled ? 'you' : 'we'} are shipping.`,
      onSave: (selectedProductsIds: string[]) => {
        setFieldValue('selectedProductsIds', selectedProductsIds)
      },
    })

  return (
    <Subsection title="Products in this group" borderless noMargin>
      <div style={{ marginTop: -8 }}>
        <SelectedProducts
          maxHeight={media.laptop ? 400 : 290}
          data={Object.values(offersByIdsQuery.data || [])}
          isLoading={offersByIdsQuery.isLoading}
          productsCount={values.selectedProductsIds.length}
          error={submitCount ? errors.selectedProductsIds : undefined}
          onAddProducts={openSelectProductsModal}
          onRemoveProduct={(removedProductId) => {
            setFieldValue(
              'selectedProductsIds',
              values.selectedProductsIds.filter((productId) => productId !== removedProductId),
            )
          }}
        />
      </div>
    </Subsection>
  )
}
